import { useEffect } from "react";

import { loadBuildConfig } from "@tdp/core";


export const useDocumentTitle = (title: string): void => {
  const envConfig = loadBuildConfig();
  const base: string = envConfig.BASE_DOCUMENT_TITLE ?? "Developer Portal";
  useEffect(() => {
    document.title = `${title}: ${base}`;

    return () => {
      document.title = base;
    };
  }, [title]);
};
